<template>
  <tr class="border-b-1 border-b-gray-600">
    <th>
      <sort-control
        field="title"
        :selected="currentSortField === 'title'"
        v-on="listeners"
        >Title</sort-control
      >
    </th>
    <th class="hide-mobile">
      <sort-control
        field="description"
        :selected="currentSortField === 'description'"
        v-on="listeners"
        >Description</sort-control
      >
    </th>
    <th class="hide-mobile">Tags</th>
    <th class="hide-mobile">Version</th>
    <th class="hide-mobile">Last Published</th>
    <th class="hide-mobile"></th>
  </tr>
</template>
<script>
import SortControl from "@/components/common/tables/SortControl.vue";

export default {
  components: { SortControl },
  props: ["currentSortField"],
  computed: {
    listeners: function () {
      // Vue 3: $listeners merged into $attrs
      return this.$attrs;
    },
  },
};
</script>
